import React from 'react';
import Routes from './cadenceTable.routes';
import { useDocumentTitle } from '../../hooks';

const CadencesPage = () => {
  useDocumentTitle('My Cadences');
  return <Routes />;
};

export default CadencesPage;
